export type CaseClinicalPolicies = {
    id: string;
    crmId: string;
    uploadDate: string;
    fileName: string | null;
    fileType: string;
    link: string | null;
    type: string;
    isOpenedDocument: boolean;
};

export const CasePolicies = 'Case Policies';
export const CaseClinicals = 'Case Clinicals';
